import { bootstrap } from '@avensia/excite/client';
import { SiteLayout } from 'nordicnest/src/app/site-layout';
import '../component-registry';
import { setupRaygunErrorLogging } from 'webapp/raygun-browser-logging';
import { AppProviders } from 'nordicnest/app-providers';
import { theme } from '../theme';
import { linkUrlDecorator } from 'webapp/link-url-decorator';
import { setLinkUrlDecorator } from '@avensia/excite/link';
import { registerChildlessProviders } from '@avensia/excite/progressive-hydration';
import '../global.css';

setLinkUrlDecorator(linkUrlDecorator);

setupRaygunErrorLogging();

registerChildlessProviders(AppProviders, () => ({
  theme,
}));
bootstrap(
  <AppProviders theme={theme}>
    <SiteLayout />
  </AppProviders>,
);
